import React from "react";
import { Link } from "react-router-dom";

const SearchComponent = ({
  searchedResult,
  setSearchQuery,
  searchQuery,
  searchLoading,
  setIsSearchOpen,
  setHeadingClicked,
}) => {
  const handleClick = () => {
    setIsSearchOpen(false);
    setHeadingClicked(false);
  };

  return (
    <div className="w-[800px] m-auto rounded-xl bg-[#e8e8e8] text-[#d7d7d7]">
      <input
        onChange={(e) => setSearchQuery(e.target.value)}
        className="bg-[#ffffff] w-full m-auto rounded-xl text-[#505256] px-4 py-2 h-[3.5rem] outline-none "
        placeholder="Search..."
      />

      {searchQuery === "" ? (
        <div className="w-full h-[3rem] flex justify-center items-center text-gray-800">
          No results
        </div>
      ) : !searchLoading ? (
        <div className="w-full text-[#707070]">
          {searchedResult !== null ? (
            <div className="flex flex-col px-4 py-2 h-fit max-h-[30rem] bg-[#e8e8e8] rounded-xl overflow-y-auto HelperPageContentScroll">
              {searchedResult.map((result) => {
                const startIdx = result.idx;
                const endIdx = startIdx + searchQuery.length;

                const beforeQuery = result.snippet.substring(0, startIdx);
                const queryText = result.snippet.substring(startIdx, endIdx);
                const afterQuery = result.snippet.substring(endIdx);

                return ( 
                  <div
                    onClick={handleClick}
                    className="border-b w-full border-[#bdc2cb] hover:bg-[#ccccccdd] transition-colors hover:rounded-md "
                  >
                    <Link
                      key={result._id}
                      to={`/help/${result._id}`}
                      className="block px-2 py-1"
                    >
                      <h2 className="text-[#505256] py-[0.8rem] text-base FontFamily-Avenir ">
                        {result.subheading}
                      </h2>
                      <h2 className="text-sm text-[#707070] FontFamily-Avenir-reg ">
                        {result.tertiarySubHeading}
                      </h2>
                      <p className="text-sm mt-[0.8rem] text-[#707070] FontFamily-Avenir-reg break-normal">
                        {beforeQuery}
                        <span className="bg-[#57a5e0] text-black FontFamily-Avenir-reg ">
                          {queryText}
                        </span>
                        {afterQuery}
                      </p>
                    </Link>
                  </div>
                );
              })}
            </div>
          ) : null}
        </div>
      ) : (
        <div className="w-full h-[15rem] flex justify-center items-center">
          <div className="loader"></div>
        </div>
      )}
    </div>
  );
};

export default SearchComponent;
